<ion-content
  scrollbar
  class="submission__container ion-content-padding-top-0"
>
  <ion-grid>
    <app-list-header *ngIf="!this.showLoader"
      (toggleFilter)="onToggleFilter()"
      [absoluteFilterButton]="true"
    >
      <ng-container top>
        <div class="chart">
          <apx-chart
            [series]="chartOptions.series"
            [chart]="chartOptions.chart"
            [xaxis]="chartOptions.xaxis"
            [stroke]="chartOptions.stroke"
            [markers]="chartOptions.markers"
            [colors]="chartOptions.colors"
            [grid]="chartOptions.grid"
            [yaxis]="chartOptions.yaxis"
            [title]="chartOptions.title"
            [noData]="chartOptions.noData"
          ></apx-chart>
        </div>
        <hr class="margin-divider" *ngIf="p.renderMobile" />
      </ng-container>

      <ng-container bottom *ngIf="!p.renderMobile">
        <div class="display-flex ion-align-items-center">
          <app-select-dropdown
          class="submission__filter"
          [data]="dictionaryServ.reportStatusValues"
          displayKey="key"
          (changeValueEvent)="onFilterStatus($event)"
          placeholder="REPORT.STATUS"
          [value]="reportServ.reportFilter.status"
        ></app-select-dropdown>
        <app-select-dropdown
          class="submission__filter"
          [data]="dictionaryServ.reportPriorityValues"
          displayKey="key"
          (changeValueEvent)="onFilterPriority($event)"
          placeholder="REPORT.PRIORITY"
          [value]="reportServ.reportFilter.priority"
        ></app-select-dropdown>
        </div>
      </ng-container>
    </app-list-header>

    <app-pagination-client-side
      [ngClass]="{ 'height-0': showLoader }"
      [componentRef]="componentRef"
      [columns]="columnsDefinition"
      [options]="options"
      (rowsLoaderReady)="rowsLoaderServiceReady($event)"
      (refreshRequest)="getSubmissionReports()"
    ></app-pagination-client-side>

  </ion-grid>

  <div class="spin" *ngIf="showLoader">
    <app-loading-sti></app-loading-sti>
  </div>

</ion-content>
